
export default function VideoGrid() {
  const videos = [
    {
      title: 'How to Tile a Floor',
      difficulty: 'Beginner',
      difficultyColor: '#10B981',
      description: 'Master the basics of floor tiling with our comprehensive step-by-step guide.',
      thumbnail: 'https://public.readdy.ai/ai/img_res/5fa07c5c1ab2df48374bb4628e523751.jpg'
    },
    {
      title: 'How to Tile a Wall',
      difficulty: 'Beginner',
      difficultyColor: '#10B981',
      description: 'Learn the techniques for perfect wall tiling in bathrooms and kitchens.',
      thumbnail: 'https://readdy.ai/api/search-image?query=Close%20up%20of%20hands%20installing%20white%20subway%20tiles%20on%20bathroom%20wall%20using%20spacers%20and%20level%20tool%20professional%20tiling%20technique%20demonstration%20bright%20clean%20workspace%20instructional%20photography&width=400&height=225&seq=video-wall-tiling&orientation=landscape'
    },
    {
      title: 'How to Grout Tiles',
      difficulty: 'Beginner',
      difficultyColor: '#10B981',
      description: 'Achieve professional-looking grout lines with the right tools and technique.',
      thumbnail: 'https://readdy.ai/api/search-image?query=Tradesperson%20applying%20grout%20to%20tiled%20surface%20with%20rubber%20float%20tool%20close%20up%20of%20grouting%20technique%20clean%20tile%20work%20with%20even%20spacing%20professional%20tutorial%20demonstration%20style&width=400&height=225&seq=video-grouting&orientation=landscape'
    },
    {
      title: 'How to Apply Bonding Liquid',
      difficulty: 'Intermediate',
      difficultyColor: '#F2C612',
      description: 'Ensure maximum adhesion with proper bonding liquid application methods.',
      thumbnail: 'https://readdy.ai/api/search-image?query=Professional%20applying%20bonding%20primer%20liquid%20to%20concrete%20surface%20with%20roller%20brush%20preparation%20work%20for%20tiling%20clean%20workspace%20with%20product%20containers%20instructional%20photography%20style&width=400&height=225&seq=video-bonding-liquid&orientation=landscape'
    },
    {
      title: 'How to Paint Like a Pro',
      difficulty: 'Beginner',
      difficultyColor: '#10B981',
      description: 'Get flawless paint finishes with professional techniques and Best products.',
      thumbnail: 'https://readdy.ai/api/search-image?query=Professional%20painter%20applying%20smooth%20paint%20finish%20to%20interior%20wall%20with%20roller%20clean%20technique%20demonstration%20bright%20room%20with%20painting%20supplies%20and%20drop%20cloth%20tutorial%20style%20photography&width=400&height=225&seq=video-painting-pro&orientation=landscape'
    },
    {
      title: 'Choosing the Right Tile Adhesive',
      difficulty: 'Beginner',
      difficultyColor: '#10B981',
      description: 'Navigate our three-tier system to find the perfect adhesive for your project.',
      thumbnail: 'https://readdy.ai/api/search-image?query=Three%20containers%20of%20tile%20adhesive%20products%20displayed%20on%20clean%20surface%20with%20tiling%20tools%20and%20material%20samples%20product%20comparison%20setup%20professional%20photography%20bright%20lighting&width=400&height=225&seq=video-choosing-adhesive&orientation=landscape'
    },
    {
      title: 'Common Tiling Mistakes to Avoid',
      difficulty: 'Intermediate',
      difficultyColor: '#F2C612',
      description: 'Learn from the pros what not to do when tiling your next project.',
      thumbnail: 'https://readdy.ai/api/search-image?query=Split%20screen%20showing%20correct%20and%20incorrect%20tiling%20techniques%20side%20by%20side%20comparison%20of%20tile%20installation%20methods%20educational%20demonstration%20with%20clear%20visual%20contrast%20tutorial%20photography&width=400&height=225&seq=video-tiling-mistakes&orientation=landscape'
    },
    {
      title: 'Which Best Tier Is Right for You?',
      difficulty: 'Beginner',
      difficultyColor: '#10B981',
      description: 'Understand our Everyday, Contractor Grade, and Elite Pro product ranges.',
      thumbnail: 'https://readdy.ai/api/search-image?query=Three%20tier%20product%20display%20showing%20Everyday%20Contractor%20Grade%20and%20Elite%20Pro%20building%20materials%20organized%20presentation%20with%20clear%20labeling%20professional%20product%20photography%20clean%20background&width=400&height=225&seq=video-tier-guide&orientation=landscape'
    }
  ];

  return (
    <section className="py-12 md:py-24 px-4 md:px-8 bg-white overflow-x-hidden">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10 md:mb-16">
          <h2
            className="text-2xl md:text-4xl font-bold mb-4"
            style={{ fontFamily: 'Montserrat, sans-serif' }}
          >
            Video Tutorials
          </h2>
          <p className="text-base md:text-lg text-gray-600">
            Watch, learn, and build with confidence
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-8">
          {videos.map((video, index) => (
            <div
              key={index}
              className="bg-white rounded-lg shadow-sm hover:shadow-md transition-shadow overflow-hidden cursor-pointer group w-full"
            >
              {/* 16:9 thumbnail */}
              <div className="relative w-full" style={{ paddingBottom: '56.25%' }}>
                <img
                  src={video.thumbnail}
                  alt={video.title}
                  className="absolute inset-0 w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                />
                <div className="absolute inset-0 bg-black/30 flex items-center justify-center">
                  <div className="w-14 h-14 md:w-16 md:h-16 bg-[#F2C612] rounded-full flex items-center justify-center group-hover:scale-110 transition-transform">
                    <i className="ri-play-fill text-2xl md:text-3xl text-[#1A1A1A]"></i>
                  </div>
                </div>
              </div>

              <div className="p-4 md:p-6">
                {/* Difficulty badge — always fully visible */}
                <div className="mb-3">
                  <span
                    className="inline-block text-xs font-semibold px-3 py-1 rounded-full whitespace-nowrap"
                    style={{
                      backgroundColor: `${video.difficultyColor}20`,
                      color: video.difficultyColor,
                    }}
                  >
                    {video.difficulty}
                  </span>
                </div>
                {/* Title — full wrap, no truncation */}
                <h3
                  className="text-base md:text-lg font-bold mb-2 leading-snug"
                  style={{ fontFamily: 'Montserrat, sans-serif' }}
                >
                  {video.title}
                </h3>
                <p className="text-sm text-gray-600 leading-relaxed">
                  {video.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
